export const defaultCheckSummary = {
inspection_date: null,
  start_time: null,
  end_time: null,
  previous_at: null,
  reason: null,
  inspector: null,
  intensity: null,
  gal_top_x: null,
  gal_top_y: null,
  gal_top_z: null,
  gal_base_x: null,
  gal_base_y: null,
  gal_base_z: null,
  is_body_top_crack: false,
  is_body_top_facility: false,
  is_body_surface_crack: false,
  is_body_surface_leak: false,
  dam_body_other: false,
  is_reservoir_slope_landslide: false,
  reservoir_other: false,
  is_gate_crack: false,
  is_gate_leak: false,
  is_gate_equipment_anomaly: false,
  gate_other: false,
  is_communication_equipment_anomaly: false,
  is_observation_equipment_anomaly: false,
  is_alarm_equipment_anomaly: false,
  is_backup_power_anomaly: false,
  is_other_equipment_anomaly: false,
  inspection_detail_result: false,
  is_body_top_crack_note: "",
  is_body_top_facility_note: "",
  is_body_surface_crack_note: "",
  is_body_surface_leak_note: "",
  dam_body_other_note: "",
  is_reservoir_slope_landslide_note: "",
  reservoir_other_note: "",
  is_gate_crack_note: "",
  is_gate_leak_note: "",
  is_gate_equipment_anomaly_note: "",
  gate_other_note: "",
  is_communication_equipment_anomaly_note: "",
  is_observation_equipment_anomaly_note: "",
  is_alarm_equipment_anomaly_note: "",
  is_backup_power_anomaly_note: "",
  is_other_equipment_anomaly_note: "",
  inspection_detail_result_note: "",
};